export default class EmploymentExternalCalendarConnections {
  items = []

  constructor(data = []) {
    this.items = data
  }

  all() {
    return this.items
  }

  findByService(service) {
    return this.items.find(connection => connection.service === service)
  }

  filterByProvider(provider) {
    return this.items.filter(connection => connection.provider === provider)
  }

  findById(connectionKey) {
    return this.items.find(connection => connection.id === connectionKey)
  }
}
